import {useEffect} from "react";
import {useLocation} from "react-router-dom";
import {useFeatureFlag} from "../../../hooks/useFeatureFlag";

const SenjaScriptManager = () => {
  const location = useLocation();

  const isSenjaEnabled = useFeatureFlag('senjaWidgetFeatureFlag');

  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  useEffect(() => {
    if (!isSenjaEnabled || isMobile) {
      return;
    }
    const desiredPaths = ["/trial", "/sign-up"];
    const scriptId = "senja-widget-script";
    if (desiredPaths.includes(location.pathname)) {
      if (!document.getElementById(scriptId)) {
        const script = document.createElement("script");
        script.id = scriptId;
        script.src = "https://widget.senja.io/widget/b7c19897-6a81-4ba8-96bb-39275f57386a/platform.js";
        script.type = "text/javascript";
        script.async = true;
        document.body.appendChild(script);
      }
    } else {
      const existingScript = document.getElementById(scriptId);
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
      const toastElements = document.querySelectorAll(".senja-embed");
      toastElements.forEach((element) => element.remove());
    }
  }, [location.pathname]);

  return null;
};

export default SenjaScriptManager;